// @ts-expect-error No types
import bender from 'hubspot.bender';
export class PDFViewerManager {
  constructor() {
    this.viewer = null;
    this.eventBus = null;
    this.linkService = null;
    this.pdf = null;
    this.container = null;
    this.callbacks = null;
    this.initialZoom = 1;
    this.initialPageIndex = 0;
    this.ViewerConstructor = null;
    this.handlePagesInit = () => {
      if (this.viewer) {
        this.viewer.currentScale = this.initialZoom;
        this.viewer.currentPageNumber = this.initialPageIndex + 1;
      }
    };
    this.handlePageChanging = event => {
      const {
        pageNumber,
        previous
      } = event;
      if (pageNumber !== previous && this.callbacks) {
        this.callbacks.onPageChange({
          pageIndex: pageNumber - 1,
          leavingPageNumber: previous,
          enteringPageNumber: pageNumber
        });
      }
    };
  }
  async load(url, callbacks, options) {
    this.callbacks = callbacks;
    this.initialPageIndex = options.pageIndex;
    this.initialZoom = options.zoom;
    const {
      PDFJS,
      EventBus,
      PDFLinkService,
      PDFSinglePageViewer
    } =
    // @ts-expect-error No types
    await import( /* webpackChunkName: "pdf-js" */'./pdf-js');
    this.ViewerConstructor = PDFSinglePageViewer;
    this.eventBus = new EventBus();
    this.linkService = new PDFLinkService({
      eventBus: this.eventBus
    });
    this.eventBus.on('pagesinit', this.handlePagesInit);
    this.eventBus.on('pagechanging', this.handlePageChanging);
    const pdfjs = PDFJS;
    const task = pdfjs.getDocument({
      url,
      cMapUrl: `${bender.staticDomainPrefix}${bender.depPathPrefixes['pdf-js']}/cmaps/`,
      cMapPacked: true,
      isEvalSupported: false
    });
    task.onProgress = ({
      loaded,
      total
    }) => {
      var _this$callbacks;
      (_this$callbacks = this.callbacks) === null || _this$callbacks === void 0 || _this$callbacks.onProgress(loaded / total * 100);
    };
    this.pdf = await task.promise;
    this.linkService.setDocument(this.pdf, null);
    this.tryCreateViewer();
    this.callbacks.onReady(this.pdf);
  }
  setContainer(container) {
    this.container = container;
    this.tryCreateViewer();
  }
  tryCreateViewer() {
    if (!this.container || !this.pdf || !this.eventBus || !this.linkService || !this.ViewerConstructor || this.viewer) {
      return;
    }
    this.viewer = new this.ViewerConstructor({
      container: this.container,
      eventBus: this.eventBus,
      linkService: this.linkService
    });
    this.linkService.setViewer(this.viewer);
    this.viewer.setDocument(this.pdf);
  }
  setPage(pageIndex) {
    if (this.viewer) {
      this.viewer.currentPageNumber = pageIndex + 1;
    }
  }
  setZoom(zoom) {
    if (this.viewer) {
      this.viewer.currentScale = zoom;
    }
  }
  destroy() {
    var _this$eventBus, _this$eventBus2;
    (_this$eventBus = this.eventBus) === null || _this$eventBus === void 0 || _this$eventBus.off('pagesinit', this.handlePagesInit);
    (_this$eventBus2 = this.eventBus) === null || _this$eventBus2 === void 0 || _this$eventBus2.off('pagechanging', this.handlePageChanging);
    this.viewer = null;
    this.eventBus = null;
    this.linkService = null;
    this.pdf = null;
    this.container = null;
    this.callbacks = null;
  }
}